import { DndContext, DragEndEvent } from '@dnd-kit/core';
import React from "react";
import { AgendaItem, PublicAmorgUser, agendaItemHelper, rng, stringUtil } from "../../../amorg-common";
import { createAgendaItem, moveAgendaItemToIndex } from "../../../api/activityClientApi";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { PageSection } from '../../../designSystem/PageSection';
import { AgendaItemPanel } from './AgendaItemPanel';
import { Card } from '../../../designSystem/Card';


type AgendaItemListPanelProps = {
    activityId: string,
    agendaItems: AgendaItem[],
    users: PublicAmorgUser[],
    onUpdated: () => void;
};
export function AgendaItemListPanel (props: AgendaItemListPanelProps): JSX.Element
{
    const [expandedIds, setExpandedIds] = React.useState<string[]>([]);

    React.useEffect(() =>
    {
        // Remove expanded ids that are no longer in the list
        if (expandedIds.some(id => props.agendaItems.every(ai => ai.id !== id)))
            setExpandedIds(expandedIds.filter(id => props.agendaItems.some(ai => ai.id === id)));
    }, props.agendaItems);

    async function handleClickCreateAgendaItem ()
    {
        const nameBase = 'Nyt agendapunkt';
        const nextTitle = stringUtil.generateNextSequenceValue(nameBase, props.agendaItems.map(ap => ap.title));
        const id = rng.getRandomId();

        const result = await createAgendaItem(id, props.activityId, nextTitle, '', '');
        if (result.isSuccess)
        {
            props.onUpdated();
            setExpandedIds([id]);
        }
    }

    const sorted = agendaItemHelper.getSortedAgendaItems(props.agendaItems);

    async function handleDragEnd(event: DragEndEvent)
    {
        const sourceId = event.active.id.toString().substring(7);
        const targetId = event.over?.id.toString().substring(7);

        if(!targetId || sourceId === targetId)
            return;

        const rootAgendaItems = sorted.filter(ai => ai.parentId === '');
        const sourceIndex = rootAgendaItems.findIndex(ai => ai.id === sourceId);
        const targetIndex = rootAgendaItems.findIndex(ai => ai.id === targetId);
        if(sourceIndex === -1 || targetIndex === -1)
            return;

        const result = await moveAgendaItemToIndex(sourceId, props.activityId, targetIndex);
        if(result.isSuccess)
            props.onUpdated();
    }

    return (
        <Flex flexDirection="column" gap={8}>
            <PageSection
                header={{
                    title: 'Agenda',
                    button: {
                        icon: "actions_plus",
                        variant: "filled",
                        size: '32px',
                        text: "Opret agendapunkt",
                        emphasize: true,
                        onClick: handleClickCreateAgendaItem
                    }
                }}
                headerStyleVariant='minimal'
                contentStyleVariant='minimal'
            >
                <Flex gap={24} flexDirection="column">
            
                    {sorted.length === 0 &&
                        <Card variant='outlined'>
                            <div style={{maxWidth:'1000px', margin:'0px auto'}}>
                                <i>Agendapunkter hjælper med at skabe struktur på mødet, så tiden bliver brugt bedst muligt, og gør det nemt at dokumentere og følge op på diskussioner og vedtagne handlepunkter.</i>
                            </div>
                        </Card>
                    }

                    <DndContext onDragEnd={handleDragEnd}>
                        <Flex flexDirection="column" gap={32}>
                            {sorted.map((ai,i) =>
                                <AgendaItemPanel key={ai.id}
                                    activityId={props.activityId}
                                    agendaItem={ai}
                                    agendaItemIndex={i}
                                    agendaItemsCount={props.agendaItems.length}
                                    users={props.users}
                                    isDragEnabled={ai.parentId === ''}
                                    expanded={expandedIds.includes(ai.id)}
                                    onUpdated={props.onUpdated}
                                    onToggleExpand={(id, expand) =>
                                    {
                                        if (expand)
                                            setExpandedIds([...expandedIds, id]);
                                        else
                                            setExpandedIds(expandedIds.filter(tId => tId !== id));

                                    }} />
                            )}
                        </Flex>
                    </DndContext>
                </Flex>    
            </PageSection>

            
        </Flex>
    );
}